import {
  createTopLevelAction,
  createViewerAction,
} from "../../core/make-action";
import TopLevelMethod from "../../core/TopLevelMethod";
import ViewerMethod from "../../core/ViewerMethod";
import { getPreferenceItem, UserBookPreference, UserPreference } from "./utils";

function createActions<T>(baseMethod) {
  return {
    set: (key: T, value: unknown) => (dispatch) => {
      dispatch(
        baseMethod({
          [(key as unknown) as string]: getPreferenceItem(value),
        })
      );
    },
    delete: (key: T) => (dispatch) =>
      dispatch(baseMethod({ [(key as unknown) as string]: {} })),
  };
}

export const { set: setUserPref, delete: deleteUserPref } = createActions<
  UserPreference
>(createTopLevelAction(TopLevelMethod.UPDATE_USER_PREFS));

export const {
  set: setUserBookPref,
  delete: deleteUserBookPref,
} = createActions<UserBookPreference>(
  createViewerAction(ViewerMethod.UPDATE_USER_BOOK_PREFS)
);
